import { z } from "zod"

export const octopiaRepairIdentitySchema = z
  .object({
    sellerProductReference: z.string().min(1).max(200),
    gtin: z.string().regex(/^\d{8,14}$/),
  })
  .strict()
export const octopiaRepairDecisionSchema = z
  .object({
    configSku: z.string().min(1).max(200),
    reference: z.string().min(1).max(1000),
    kind: z.enum(["content", "family"]),
    categoryCode: z.string().min(1).max(20),
    acceptedCategoryCodes: z.array(z.string().min(1).max(20)).min(1).max(10),
    categoryReview: z.string().min(1).max(2000),
    familyReference: z.string().regex(/^[A-Za-z0-9_]{1,100}$/),
    variationProperties: z.array(z.string().min(1)).min(1).max(10),
  })
  .strict()
export const octopiaFamilyEvidenceSchema = z
  .object({
    policy: z.literal("octopia-reviewed-family-v1"),
    configSku: z.string(),
    familyReference: z.string(),
    accountScope: z.string(),
    rootUploadId: z.string(),
    decision: octopiaRepairDecisionSchema,
    identities: z.array(octopiaRepairIdentitySchema).min(1),
    acceptedKeys: z.array(z.string()),
    observationDigest: z.string(),
    observedAt: z.string().datetime(),
    actor: z.string(),
  })
  .strict()
export const octopiaRepairFamilySchema = z
  .object({ rootUploadId: z.string().min(1), decision: octopiaRepairDecisionSchema })
  .strict()
export const octopiaRepairWorklistSchema = z
  .object({
    rootUploadId: z.string().min(1),
    cursor: z.number().int().nonnegative().default(0),
    limit: z.number().int().min(1).max(100).default(50),
    resolution: z.enum(["integrated", "content_failed", "pending", "held"]).optional(),
    refresh: z.boolean().default(false),
    keys: z.array(octopiaRepairIdentitySchema).min(1).max(500).optional(),
    packageIds: z.array(z.string().uuid()).max(100).default([]),
  })
  .strict()
export const octopiaRepairPreviewSchema = z
  .object({
    rootUploadId: z.string().min(1),
    keys: z.array(octopiaRepairIdentitySchema).min(1).max(10000),
    decisions: z.array(octopiaRepairDecisionSchema).min(1).max(1000),
    reason: z.string().min(1).max(4000),
    parentPlanId: z.string().min(1).optional(),
  })
  .strict()
export const octopiaRepairConfirmSchema = z
  .object({ planId: z.string().min(1), confirmHash: z.string().regex(/^[a-f0-9]{64}$/) })
  .strict()
export const octopiaRepairStatusSchema = z
  .object({
    rootUploadId: z.string().min(1).optional(),
    planId: z.string().min(1).optional(),
    cursor: z.number().int().nonnegative().default(0),
    limit: z.number().int().min(1).max(100).default(50),
    refresh: z.boolean().default(false),
  })
  .strict()
  .refine(
    (value) => Boolean(value.rootUploadId) !== Boolean(value.planId),
    "Choose rootUploadId or planId"
  )
export type OctopiaRepairDecision = z.infer<typeof octopiaRepairDecisionSchema>
export type OctopiaRepairPreviewInput = z.infer<typeof octopiaRepairPreviewSchema>
